module.exports = __webpack_public_path__ + "img/headline_background.90435587.png";